export default "__VITE_ASSET__BmnMxy06__"